import { useEffect, useState } from 'react'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography, } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { estaNoElectron } from '../../../lib/balanca'

export function SobreAparelho(): JSX.Element {
  const [aberto, setAberto] = useState(false)
  const [confirmando, setConfirmando] = useState(false)
  const [kioskAtivo, setKioskAtivo] = useState<boolean | null>(null)
  const [atualizacao, setAtualizacao] = useState<{
    versaoAtual: string
    versao: string | null
    baixada: boolean
    progresso: number
  } | null>(null)
  const noElectron = estaNoElectron()

  async function sairDoKiosk(): Promise<void> {
    await window.pdvDesktop?.setKioskMode?.(false)
  }

  useEffect(() => {
    if (!aberto || !noElectron) return

    let vivo = true
    void Promise.resolve(window.pdvDesktop?.isKioskMode?.() ?? false)
      .then((v) => { if (vivo) setKioskAtivo(!!v) })
      .catch(() => undefined)

    return () => { vivo = false }
  }, [aberto, noElectron])

  useEffect(() => {
    if (!aberto || !noElectron) return

    let vivo = true
    void window.pdvDesktop?.estadoAtualizacao?.()
      .then((e) => { if (vivo && e) setAtualizacao(e) })
      .catch(() => undefined)

    return () => { vivo = false }
  }, [aberto, noElectron])

  function fechar(): void {
    setAberto(false)
    setConfirmando(false)
  }

  return (
    <>
      <Button
        size="small"
        startIcon={<InfoOutlinedIcon fontSize="small" />}
        onClick={() => setAberto(true)}
        sx={{
          position: 'fixed',
          left: 8,
          bottom: 8,
          textTransform: 'none',
          opacity: 0.5,
          transition: 'opacity .2s',
          '&:hover, &:focus-visible': { opacity: 1 },
        }}
      >
        Sobre
      </Button>

      <Dialog open={aberto} onClose={fechar} fullWidth maxWidth="xs">
        <DialogTitle>Configuração do Totem</DialogTitle>

        <DialogContent>
          <Stack spacing={2}>
            {atualizacao && (
              <Stack spacing={0.5}>
                <Typography variant="body2" color="text.secondary">
                  Versao instalada: <strong>{atualizacao.versaoAtual}</strong>
                </Typography>

                {atualizacao.baixada && (
                  <Typography variant="body2" color="success.main">
                    Versao {atualizacao.versao} pronta — sera aplicada quando o totem ficar ocioso.
                  </Typography>
                )}

                {!atualizacao.baixada && atualizacao.versao && (
                  <Typography variant="body2" color="text.secondary">
                    Baixando a versao {atualizacao.versao}... {atualizacao.progresso}%
                  </Typography>
                )}
              </Stack>
            )}

            {noElectron && kioskAtivo && (
              <>
                {confirmando ? (
                  <Alert severity="warning" icon={false}>
                    <Typography variant="body2" sx={{ mb: 1.5 }}>
                      O aplicativo será reiniciado fora do modo kiosk e a área de trabalho do
                      Windows fica acessível. Use apenas durante a instalação.
                    </Typography>

                    <Stack direction="row" spacing={1}>
                      <Button size="small" variant="contained" color="warning" onClick={() => void sairDoKiosk()}>
                        Sair do kiosk
                      </Button>

                      <Button size="small" color="inherit" onClick={() => setConfirmando(false)}>
                        Cancelar
                      </Button>
                    </Stack>
                  </Alert>
                ) : (
                  <Button
                    variant="outlined"
                    color="warning"
                    startIcon={<LockOpenIcon />}
                    sx={{ textTransform: 'none' }}
                    onClick={() => setConfirmando(true)}
                  >
                    Sair do modo kiosk
                  </Button>
                )}
              </>
            )}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={fechar}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
